import { Spacer, VDBText } from "@components/atoms";
import { useTranslation } from "react-i18next";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { SpaceType } from "@components/atoms/Spacer/types";
import React from "react";
import { formatNumberWithPrecision } from "@utils/product/productFormatters";

const ReviewHeaderDetails = ({
  itemDetail,
  stoneItemDetail,
  matchingPairItemDetail,
}: any) => {
  const { t } = useTranslation();
  const { theme, typography } = useScreenOptionsHooks();
  const center_stone = stoneItemDetail.size;
  const side_stone = itemDetail.side_stone_size;
  const matchingPairStoneSize = matchingPairItemDetail?.size || 0;
  const total_weight = formatNumberWithPrecision(
    Number(stoneItemDetail.size) +
      Number(itemDetail.side_stone_size) +
      Number(matchingPairStoneSize),
    { precision: 2 }
  );
  return (
    <Overlay>
      <VDBText type={typography["Large-B"]} color={theme["core-05"]}>
        {t("reviewPage.screentext.header.text", {
          x: itemDetail?.jewelry_type,
        })}
      </VDBText>
      <Spacer size={SpaceType.Basic} />
      <VDBText type={typography["H2-R"]} color={theme["core-06"]}>
        {center_stone && center_stone !== 0 && (
          <>
            {center_stone} {t("reviewPage.screentext.header.centerStone.text")}
            {" | "}
          </>
        )}
        {side_stone && side_stone !== 0 && (
          <>
            {side_stone} {t("reviewPage.screentext.header.sideStone.text")}
            {" | "}
          </>
        )}
        {total_weight} {t("reviewPage.screentext.header.totalWeight.text")}
      </VDBText>
    </Overlay>
  );
};

export default ReviewHeaderDetails;

const Overlay = styled.View`
  padding-vertical: ${SpaceType.Double};
`;
